import { http } from '@/core/api/';

export const getHistory = async (obj) => {
  try {
    const { data } = await http.get(`api/tapRequests/statusHistory`, {
      params: {
        ...obj,
      },
    });
    return data || null;
  } catch {
    return null;
  }
};
